<template>
  <div class="content">
    <div class="text">{{text}}</div>
  </div>
</template>
<script>
export default {
  props:{
    text:String,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>

.content{
    .text {
    padding: 10px 24px 30px;
    font-size: 15PX;
    font-family: @family;
    font-weight: 400;
    color: #5f697d;
    line-height: 30px;
  }
}
</style>
